import classNames from 'clsx';
import React from 'react';

import BackgroundImage from '../../assets/path_identity.svg';

import styles from './Card.scss';

export interface CardProps {
  image: string;
  className: string;
}

const PassCard: React.FC<CardProps> = ({ image, className }) => (
  <div className={classNames(styles.card, styles.passCard)}>
    <BackgroundImage
      className={classNames(styles.passBackground, styles[className as keyof typeof styles])}
    />
    <div className={styles.passContainer}>
      <img src={image} width={230} height={132} alt={`${className} pass ticket graphic`} />
    </div>
  </div>
);

export default PassCard;
